module.exports = __webpack_public_path__ + "static/media/fullsize.54eae1f9.png";